// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"y7-z"};